<script>
import { FULL_ROLE_AGENT_EDIT } from '@utils/helpers'
import store from '@state/store'

export default {
  props: {
    type: {
      validator: function(value) {
        return !!~['add', 'view', 'edit'].indexOf(value)
      },
      default: 'add',
    },
    errors: {
      type: Object,
      default: () => {},
    },
    triggerMask: {
      type: Boolean,
      require: false,
    },
    notificationDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      currentUser: store.getters['auth/getCurrentUser'],
      editable: false,
      fields: {
        schedule_start: '',
        schedule_end: '',
      },
    }
  },
  computed: {
    add() {
      return this.type === 'add'
    },
    view() {
      return this.type === 'view'
    },
    edit() {
      return this.type === 'edit'
    },
    isHideEditComputed() {
      return (
        this.add ||
        this.notificationDetail.status !== 0 ||
        !FULL_ROLE_AGENT_EDIT.includes(this.currentUser.level)
      )
    },
  },
  watch: {
    notificationDetail() {
      this.fields = {
        schedule_start: this.notificationDetail.schedule_start || '',
        schedule_end: this.notificationDetail.schedule_end || '',
      }
    },
    type() {
      if (this.type === 'view') {
        this.editable = false
      } else if (this.type === 'edit') {
        this.editable = true
      }
    },
  },
  methods: {
    toggleEditable() {
      this.editable = !this.editable
      this.$emit('enable:edit', this.editable)
    },
    handleChangeScheduleDate(value) {
      const fields = {
        schedule_start: value.date_start,
        schedule_end: value.date_end,
      }
      this.fields = fields
      this.$emit('change', fields)
    },
    handleSubmit() {
      this.$emit('edit:notification', this.fields)
    },
  },
}
</script>

<template>
  <div id="notification_agentadmin-delivery-period">
    <BaseCardDetail
      title="配信期間"
      form-collapsed
      :errors="errors"
      :trigger-mask="!editable && triggerMask"
      :has-footer="!add && editable"
      @edit="toggleEditable"
      @cancel="toggleEditable"
      @submit="handleSubmit"
    >
      <template v-if="isHideEditComputed" v-slot:header-action>
        <div />
      </template>
      <CRow>
        <CCol sm="3" class="d-flex align-items-center">
          <div class="col-form-label">
            期間
            <span class="text-danger">*</span>
          </div>
        </CCol>
        <CCol sm="9">
          <BaseDateRangerPicker
            picker-type="datetime"
            :vee-name-start="'schedule_start'"
            :vee-name-end="'schedule_end'"
            :readonly="view"
            :disabled="view"
            :rules="{ required: true }"
            :rules-start="{ timeAfterNow: true }"
            :start-date="fields.schedule_start"
            :end-date="fields.schedule_end"
            @update:value="handleChangeScheduleDate"
          />
        </CCol>
      </CRow>
    </BaseCardDetail>
  </div>
</template>
